import styles from '../register-style.css';
import appStyles from '../../styles/app-styles.scss';
import { 
	SimpleSpinner, 
	MessageBox,
	apiFetchWithErrorCheck,
	classes
} from 'component-library';

//various componets and functions brought in for use.
const { useState } = wp.element;

/*The registration form component
props:
	nonceName, string, the nonce name
	nonce, string, the nonce
*/

export function RegistrationForm(props) {
	//the nonce settings, name is the name of the nonce, nonce is the actual setting
	let { nonceName, nonce } = props;
	//the registration data
	const [registrationSettings, setRegistrationSettings] = useState({
			email:null,
			firstName:null,
			lastName:null, 
			termsConditions:false, 
			password:null, 
			nonceName:nonceName, 
			nonce:nonce 
		}),
		[message, setMessage] = useState({message:'', messageType:null}),
		[spinner, setSpinner] = useState(false);
		

	//change state settings from the form
	function changeSettings(e) {
		let {name, value} = e.target;
		if (name == 'termsConditions') {
			value = (value === "true");
		}
		setRegistrationSettings({...registrationSettings, [name]:value});
	}
	//register the state
	function register(e) {
		e.preventDefault();
		setSpinner(true);
		apiFetchWithErrorCheck({path:'/rf/v1/user', data:registrationSettings})
		.then((response) =>  {
			setSpinner(false);
			if (response == undefined || response == 'error') {return;} 
			if (response['error'] !== undefined ) {
				setMessage({message:response['error'], messageType:'alert'});
				return;
			}
			
			setMessage({message:response['result'], messageType:'success'});
		})
		.catch((error) => {
			setMessage({message:error.message, messageType:'alert'});
			setSpinner(false);
		});
	}
	//the form
	return(<div>
		<h2>Register</h2>
		<p>Following registration you will be able to comment on various sections of the different Frameworks within the Network; please complete the registration process and read the <a  href="https://researchframeworks.org/terms-and-conditions/"> Terms and Conditions</a> and <a  href="https://researchframeworks.org/privacy-policy/">Privacy Policy</a>. We look forward to seeing your contributions and hearing about your research/work.
</p>
		<form method="POST" onSubmit={register}>
		<label className={styles.label} >
			Email (required)
			<input 
				type="email" 
				name="email" 
				value={registrationSettings.email} 
				onChange={changeSettings} 
				className={styles.input}
				required="required"
			/>
		</label>
		<label className={styles.label} >
			First Name (required)
			<input 
				type="text" 
				name="firstName" 
				value={registrationSettings.firstName} 
				onChange={changeSettings} 
				required="required"
				className={styles.input}
			/>
		</label>
		<label className={styles.label} >
			Surname/last Name (required)
			<input 
				type="text" 
				name="lastName" 
				value={registrationSettings.lastName} 
				onChange={changeSettings} 
				required="required"
				className={styles.input}
			/>
		</label>
		<label className={styles.label} >
			Password (required) 
			<input 
				type="password" 
				name="password" 
				value={registrationSettings.password} 
				onChange={changeSettings} 
				required="required"
				className={styles.input}
			/>
		</label>
		<label className={styles.label} >
			<input 
				type="checkbox" 
				defaultChecked={registrationSettings.termsConditions} 
				onClick={changeSettings} 
				name="termsConditions" 
				value={!registrationSettings.termsConditions}
				required="required"
			/>
			check to agree to the Privacy Policy (required).
		</label>
		<button className={classes(appStyles.buttonPrimary1, spinner ?styles.buttonInactive:null)} type="submit" disabled={spinner}>{spinner ? <SimpleSpinner on={spinner}/> :'Register'}</button>
		<MessageBox messageType={message.messageType}>{message.message}</MessageBox>
		</form>
	</div>);
}